// Function to initialize Swiper
const swiper = new Swiper('.swiper-image-with-text', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
  },

  breakpoints: {
    576: {
      loop: false,
      autoplay: false,
      allowTouchMove: false,
    },
  },
});
